module.exports = __webpack_public_path__ + "static/media/img-pmr.b0dae667.png";